import { render, staticRenderFns } from "./IsSuccessPage.vue?vue&type=template&id=4b2e8096&scoped=true&"
import script from "./IsSuccessPage.vue?vue&type=script&lang=js&"
export * from "./IsSuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./IsSuccessPage.vue?vue&type=style&index=0&id=4b2e8096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e8096",
  null
  
)

export default component.exports